import { cn } from '@/lib/utils';

export interface StatCardProps {
  title: string;
  value: string | number;
  change?: {
    value: number;
    label?: string;
  };
  icon?: React.ReactNode;
  className?: string;
}

export const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  change,
  className,
}) => {
  const isPositive = change && change.value >= 0;
  const isNegative = change && change.value < 0;

  return (
    <div
      className={cn(
        'bg-white rounded-lg border border-gray-200 p-3 sm:p-4 shadow-sm',
        className
      )}
    >
      <p className="text-xs sm:text-sm font-medium text-gray-500">{title}</p>
      <p className="mt-1 sm:mt-2 text-base sm:text-xl lg:text-2xl font-semibold text-gray-900">{value}</p>
      {change && (
        <div className="mt-1 sm:mt-2 flex items-center">
          <span
            className={cn(
              'inline-flex items-center text-xs sm:text-sm font-medium',
              isPositive && 'text-green-600',
              isNegative && 'text-red-600'
            )}
          >
            {isPositive && (
              <svg
                className="h-3 w-3 sm:h-4 sm:w-4 mr-0.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 10l7-7m0 0l7 7m-7-7v18"
                />
              </svg>
            )}
            {isNegative && (
              <svg
                className="h-3 w-3 sm:h-4 sm:w-4 mr-0.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 14l-7 7m0 0l-7-7m7 7V3"
                />
              </svg>
            )}
            {Math.abs(change.value).toFixed(1)}%
          </span>
          {change.label && (
            <span className="ml-1 sm:ml-2 text-xs sm:text-sm text-gray-500">{change.label}</span>
          )}
        </div>
      )}
    </div>
  );
};
